module.exports = __webpack_public_path__ + "starbackground.5a3e71825ad142a1ee9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/starbackground.jpg
// module id = 345
// module chunks = 1